import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Checkbox,
  Tooltip,
  Modal,
  Input,
  message,
  Form,
} from "antd";
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { LuArrowUpDown } from "react-icons/lu";
import { MdOutlineDone } from "react-icons/md";
import Userimg from "../../../img/userimg.svg";
import { MdBlockFlipped } from "react-icons/md";
import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../../common/Pagination";
import {
  createGroup,
  getAllGroup,
  updateGroup,
} from "../../../api/AdminRequest";
import moment from "moment";
import { useNavigate } from "react-router-dom";
const GroupList = () => {
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const tabs = [
    { value: "", label: "All" },
    { value: "active", label: "Active" },
    { value: "deactive", label: "Deactive" },
  ];
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(9);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);

  const [loader, setLoader] = useState(false);
  const [loader1, setLoader1] = useState(false);

  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, setTrigger] = useState(false);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value);
    setLimit(selectedValue);
    setCurrentPage(1);
  };

  const [activeTab, setActiveTab] = useState("");
  const [groupList, setGroupList] = useState([]);

  useEffect(() => {
    const groupCall = async () => {
      try {
        setLoader(true);
        const { data } = await getAllGroup({
          page: currentPage,
          limit: limit,
          status: activeTab,
        });

        if (data?.success) {
          // console.log(data, "data in user");

          setGroupList(data?.groupList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    groupCall();
  }, [limit, currentPage, activeTab, trigger]);

  const handleSingleView = (id) => {
    navigate("/group-single-view", { state: id });
  };

  const columns = [
    {
      title: () => <Checkbox />,
      key: "select",
      render: () => <Checkbox />,
      width: 50,
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Group Name
          <SearchOutlined className="text-[#9FACF0]" />
        </div>
      ),
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <div className="flex items-center cursor-pointer">
          <img
            src={Userimg}
            alt="Group avatar"
            className="w-8 h-8 rounded-full mr-2"
          />
          <span className="text-[#313131] text-[13px] font-medium">{text}</span>
        </div>
      ),
    },
    {
      title: <div className="flex items-center gap-2">Status</div>,
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${status === "active"
            ? "text-green-600"
            : status === "deactive"
              ? "text-gray-600"
              : "text-red-600"
            }`}
        >
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Company Domain
          <SearchOutlined className="text-[#9FACF0]" />
        </div>
      ),
      dataIndex: "domain",
      key: "domain",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">{text}</span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          No of Members
          <LuArrowUpDown className="text-[#9FACF0]" />
        </div>
      ),
      dataIndex: "members",
      key: "members",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">
          {text.length}
        </span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Started Date
          <LuArrowUpDown className="text-[#9FACF0]" />
        </div>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (
        <span className="text-[#313131] text-[13px] font-medium">
          {moment(text).format("MMM DD, YYYY")}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View Details">
            <button
              onClick={() => handleSingleView(record._id)}
              className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
            >
              <EyeOutlined style={{ fontSize: 16 }} />
            </button>
          </Tooltip>

          <Tooltip title={record.status === "active" ? "Deactivate Group" : "Activate Group"}>
            <button
              onClick={() => groupStatusAction(record._id, record.status)}
              className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all shadow-sm border ${record.status === "active"
                ? "bg-orange-50 text-orange-600 border-orange-100 hover:bg-orange-600 hover:text-white"
                : "bg-green-50 text-green-600 border-green-100 hover:bg-green-600 hover:text-white"
                }`}
            >
              <MdBlockFlipped size={16} />
            </button>
          </Tooltip>

          <Tooltip title="Delete Group">
            <button
              onClick={() => groupStatusAction(record._id, "delete")}
              className="w-8 h-8 flex items-center justify-center bg-red-50 text-red-600 rounded-lg hover:bg-red-600 hover:text-white transition-all shadow-sm border border-red-100"
            >
              <DeleteOutlined style={{ fontSize: 16 }} />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  const handleCreate = async (values) => {
    console.log(values);

    try {
      setLoader1(true);
      const { data } = await createGroup(values);

      if (data.success) {
        handleCancel();
        setLoader1(false);

        message.success("Group Created Successfully");
        setTrigger(!trigger);

        // Refresh the user list or update the local state
      } else {
        handleCancel();
        setLoader1(false);

        message.error("Failed to create group");
        setTrigger(!trigger);
      }
    } catch (error) {
      handleCancel();
      setLoader1(false);

      console.log("Error creating group:", error);
      message.error("An error occurred while creating group");
    }
  };

  const groupStatusAction = (id, currentStatus) => {
    let nextAction;
    let actionText;

    switch (currentStatus) {
      case "active":
        nextAction = { status: "deactive" };
        actionText = "deactive";
        break;
      case "delete":
        nextAction = { status: "delete" };
        actionText = "delete";
        break;
      default:
        nextAction = { status: "active" };
        actionText = "active";
    }

    Modal.confirm({
      title: "Confirm Action",
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to ${actionText} this group?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return handleUpdateGroupStatus(id, nextAction);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };
  const handleUpdateGroupStatus = async (id, action) => {
    try {
      const { data } = await updateGroup(id, action);

      if (data.success) {
        message.success("Group status updated successfully");
        setTrigger(!trigger);

        // Refresh the user list or update the local state
      } else {
        message.error("Failed to update group status");
        setTrigger(!trigger);
      }
      setTrigger(!trigger);
    } catch (error) {
      console.log("Error updating group status:", error);
      message.error("An error occurred while updating group status");
    }
  };

  return (
    <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
      <>
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-6 mt-2">
          <div className="w-full lg:w-auto overflow-x-auto scrollbar-hide py-1">
            <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white">
              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                    ${activeTab === tab.value
                      ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                      : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                    }`}
                  onClick={() => {
                    setActiveTab(tab.value);
                    setCurrentPage(1);
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-auto">
            <button
              onClick={showModal}
              className="w-full bg-[#1955EB] text-white px-8 h-10 rounded-lg font-bold hover:bg-blue-700 transition-all shadow-lg hover:shadow-blue-200 active:scale-95 text-sm"
            >
              + Create Group
            </button>
          </div>
        </div>
        <div className="pt-2">
          <Table
            columns={columns}
            loading={loader}
            dataSource={groupList}
            pagination={false}
            className="custom-table-header w-full overflow-x-auto custom-pagination border border-gray-100 rounded-xl"
          />
          <div className="mt-6">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              limit={limit}
              totalItem={totalItems}
              onPageChange={handlePageChange}
              handleLimit={handleLimit}
            />
          </div>
        </div>

        <Modal
          title={
            <div className="border-b border-[#E0E0E0] pb-3">
              <h2 className="text-[18px] font-semibold">Create Group</h2>
            </div>
          }
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
          className="w-full "
        >
          <Form
            form={form}
            onFinish={handleCreate}
            layout="vertical"
            initialValues={{
              name: "",
              domain: "",
            }}
          >
            <div className="flex justify-evenly gap-4 mt-4">
              <div className="flex flex-col">
                <Form.Item
                  name="name"
                  label="Company Name"
                  rules={[
                    { required: true, message: "Please Enter Company Name" },
                  ]}
                >
                  <Input
                    className="h-10 rounded-md"
                    placeholder="Enter Company Name"
                  />
                </Form.Item>
              </div>
              <div className="flex flex-col">
                <Form.Item
                  name="domain"
                  label="Company Domain"
                  rules={[
                    { required: true, message: "Please Enter Company Domain" },
                  ]}
                >
                  <Input
                    className="h-10 rounded-md"
                    placeholder="Enter Company Domain"
                  />
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-evenly gap-6 pt-8 px-4">
              <Button
                onClick={handleCancel}
                className="bg-white border-[#313131] border-[1px] text-[16px] font-semibold text-[#313131] w-full"
              >
                Discard
              </Button>
              <Button
                type="primary"
                className="text-white bg-[#1955EB] text-[16px] font-semibold w-full"
                loading={loader1}
                htmlType="submit"
              >
                Create
              </Button>
            </div>
          </Form>
        </Modal>
      </>
    </div>
  );
};

export default GroupList;
